import React from 'react';
import { SolutionHeader } from '../solution-header';
import style from "./style.module.css";
import { ImageTextPair } from '../image-text-pair';

export interface IFeature {
    imgSrc: string;
    title: string;
    body: string;
    altText?: string;
}

export interface IScreenGroupProps {
    title: string;
    features: IFeature[];
    chips?: string[];
    description?: string;
    startGoofy?: boolean;
}

export function ScreenGroup(props: IScreenGroupProps) {
    const startImgOnLeft = (index: number) => {
        return index % 2 === 1;
    }

    const startImgOnRight = (index: number) => {
        return index % 2 === 0;
    }

    const determinant = props.startGoofy ? startImgOnRight : startImgOnLeft;

    return (
        <section className={style.ScreenGroup}>
            <SolutionHeader
                title={props.title}
                description={props.description}
            />
            {
                props.features.map((feature: IFeature, index: number) => {
                    return (
                        <ImageTextPair
                            key={feature.title}
                            title={feature.title}
                            body={feature.body}
                            imgSrc={feature.imgSrc}
                            goofy={determinant(index)}
                        />
                    );
                })
            }
        </section>
    )
}